module.exports = __webpack_public_path__ + "media/musicMeditationNuevo.2362f0fe.mp3";